import Vue from 'vue';
import VueRouter from 'vue-router';
import login from '../views/login/login.vue';

let v = new Vue();
Vue.use(VueRouter);

const routes = [
  // {
  //   path: '/',
  //   redirect: "/login"
  // },
  {
    path: '/',
    name: 'login',
    component: login
  },
  {
    path: '/home',
    name: 'home',
    title:'首页',
    component: () => import("../components/Mybusiness/Mybusiness.vue"),
  },
  {
    path: '/m',
    name: 'm',
    title:'首页',
    component: () => import("../components/m/index.vue"),
  },
  {
    path: '/Candidate',
    name: 'Candidate',
    title:'候选人列表',
    component: () => import("../components/Candidate/Candidate-list.vue"),
  },
  {
    path: '/Candidateils',
    name: 'Candidateils',
    title:'候选人详情',
    component: () => import("../components/Candidate/Candidate-datas.vue"),
  },
  {
    path: '/Talent',
    name: 'Talent',
    title:'岗位列表',
    component: () => import("../components/Talent/Talent-list.vue"),
  },
  {
    path: '/Talentils',
    name: 'Talentils',
    title:'岗位详情',
    component: () => import("../components/Talent/Talent-datas.vue"),
  },
  {
    path: '/addtalent',
    name: 'addtalent',
    title:'新增岗位',
    component: () => import("../components/Talent/Talent-add.vue"),
  },
  {
    path: '/TalentPool',
    name: 'TalentPool',
    title:'人才信息库',
    component: () => import("../components/TalentPool/TalentPool.vue"),
  },
  {
    path: '/TalentPoolils',
    name: 'TalentPoolils',
    title:'人才信息库详情',
    component: () => import("../components/TalentPool/TalentPoold-atas.vue"),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  //    to跳转到哪个页面,
  //    from从哪个页面来,
  //    next()跳转方法,
  // 如果用户访问的是登录页,直接放行
  // if (to.path === "/login") return next();
  if (to.name === "login") return next();
  if (to.name === "m") return next();
  // 访问的不是登录页,看有没有token,没有强制跳转到登录页,token可能有，也可能是空
  let tokener = localStorage.getItem("Authorization");
  if (tokener == null || tokener == '' || tokener == undefined) {
    v.$message({
      message: '请先登录',
      type: 'warning'
    });
    router.push({
      name: 'login'
    });
    return;
  }
  next();
})


export default router